module.exports = __webpack_public_path__ + "img/x-mark.ef986dfc.svg";